/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from "react";
import { atom, useRecoilState } from "recoil";

import api from "../Api";

/**
 * 검색 결과
 */
const routesAtom = atom({
  key: "routes",
  default: null,
});

/**
 * 전체 지하철 역
 */
const stationsAtom = atom({
  key: "stations",
  default: [],
});

/**
 * 전체 노선
 */
const linesAtom = atom({
  key: "lines",
  default: [],
});

export const useStationsStore = () => {
  const [routes, setRoutes] = useRecoilState(routesAtom);
  const [stations, setStations] = useRecoilState(stationsAtom);
  const [lines, setLines] = useRecoilState(linesAtom);

  const fetchRoutes = useCallback(
    async (data) => {
      const response = await api.post(`/api/routes/search`, data);

      if (response?.status === "Success") {
        if (response?.results?.length) {
          setRoutes(response?.results);
        } else {
          window.alert("경로가 존재하지 않습니다.");
        }
      }

      return response;
    },
    [api.post],
  );

  const fetchStations = useCallback(async () => {
    const response = await api.post(`/api/stations`);

    if (response?.status === "Success") {
      let _stations = [];

      response?.results.forEach((station) => {
        if (_stations.find((s) => s.name === station.name)) {
          return;
        }

        const sameStation = response?.results.filter(
          (s) => s.name === station.name,
        );

        if (sameStation.length) {
          _stations.push({
            ...station,
            lines: sameStation
              .map((s) => s.line)
              .sort((a, b) => (a < b ? -1 : a > b ? 1 : 0)),
            external_codes: sameStation
              .map((s) => s.external_code)
              .sort((a, b) => (a < b ? -1 : a > b ? 1 : 0)),
          });
        } else {
          _stations.push({
            ...station,
            lines: [station.line],
            external_codes: [station.external_code],
          });
        }
      });

      setStations(
        _stations.sort((a, b) =>
          a.name < b.name ? -1 : a.name > b.name ? 1 : 0,
        ) || [],
      );
    }

    return response;
  }, [api.post]);

  const fetchLines = useCallback(async () => {
    const response = await api.post(`/api/lines`);

    if (response?.status === "Success") {
      setLines(response?.results || []);
    }

    return response;
  }, [api.post]);

  const reset = useCallback(() => {
    setRoutes(null);
  }, [setRoutes]);

  const state = {
    routes,
    stations,
    lines,
  };

  return { state, fetchRoutes, fetchStations, fetchLines, reset };
};
